import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Entity } from './entity';

 import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class EntityService {
	baseUrl = environment.baseUrl;
  private EntityUrl = this.baseUrl + '/api/entity';  // URL to web api
  private EntityDetailsUrl = this.baseUrl + '/api/entityDetails';  // URL to web api
 
   
  constructor( 
    private http: HttpClient
  ) { }
 
  getEntitys (): Observable<Entity[]> {
	return this.http.get<Entity[]>(this.EntityUrl)
  }
  getEntity(entityid: number): Observable<Entity> {
    const url = `${this.EntityUrl}/${entityid}`;
    return this.http.get<Entity>(url);
  }
  getEntitylist (): Observable<Entity[]> {
    return this.http.get<Entity[]>(this.baseUrl +'/api/entitylist')
  }
   GetEntityDetails(entityid: number): Observable<Entity> {
    const url = `${this.EntityDetailsUrl}/${entityid}`;
    return this.http.get<Entity>(url);
  } 
 
  addEntity (entity: Entity): Observable<Entity> {
    return this.http.post<Entity>(this.EntityUrl, entity, httpOptions);
  }
     
  deleteEntity (entity: Entity | number): Observable<Entity> {
    const entityid = typeof entity === 'number' ? entity : entity.entityid;
    const url = `${this.EntityUrl}/${entityid}`;
 
    return this.http.delete<Entity>(url, httpOptions);
  }
 
  updateEntity (entity: Entity): Observable<any> {
    return this.http.put(this.EntityUrl, entity, httpOptions);
  }

}